import { Card, Group, Image, Tooltip } from "@mantine/core";
import { API_URL, APP_ID } from "../../config";

export function BaseReportesViewColumnsOverrides(column_index: number) {
    return {
        [column_index]: {
            render: (value: unknown) => {
                const imagenes = (value as string)
                    .split(',')
                    .map((img) => img.trim())
                    .filter((img) => img);

                if (imagenes.length === 0) {
                    return '';
                }

                return (
                    <Group align="flex-start" spacing="xs">
                        {imagenes.map((img, index) => (
                            <Tooltip label=
                                {
                                    <Card>
                                        <Image
                                            key={`img-${index + 1}`}
                                            src={`${API_URL}/${APP_ID}/serve/${img}`}
                                            alt={`Imagen ${index + 1}`}
                                            maw="600px"
                                            mt="auto"
                                        />
                                    </Card>
                                }>
                                <Image
                                    key={`tooltip-${index + 1}`}
                                    src={`${API_URL}/${APP_ID}/serve/${img}`}
                                    alt={`Imagen ${index + 1}`}
                                    maw="30px"
                                    mt="auto"
                                />
                            </Tooltip>
                        ))}
                    </Group>
                );
            }
        }
    }
}